import { z } from 'zod';
import type { ModelToken } from '@sleed/bizcommerce-api';

/**
 * Model edit form. Mirrors `ModelToken` and the legacy admin grid
 * (Core/client/admin/src/pages/Catalog/Models/index.js): nm required ≤100, iv boolean,
 * si required, erpcd optional. The default-language name is saved at the top level via the
 * Accept-Language=el pin (parity with RelationTypes/Seasons).
 */
export const modelSchema = z.object({
	id: z.number().optional(),
	nm: z.string().trim().min(1, 'validation.required').max(100, 'validation.tooLong'),
	erpcd: z.string().trim().nullable(),
	iv: z.boolean(),
	si: z.number({ message: 'validation.required' }).int()
});

export type ModelFormValues = z.infer<typeof modelSchema>;

export const EMPTY_MODEL: ModelFormValues = {
	nm: '',
	erpcd: '',
	iv: true,
	si: 0
};

export function tokenToForm(token: ModelToken): ModelFormValues {
	return {
		id: token.id,
		nm: token.nm ?? '',
		erpcd: token.erpcd ?? '',
		iv: token.iv ?? false,
		si: token.si ?? 0
	};
}

export function formToToken(form: ModelFormValues): ModelToken {
	return {
		id: form.id,
		nm: form.nm.trim(),
		erpcd: form.erpcd?.trim() || null,
		iv: form.iv,
		si: form.si
	};
}
